"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const silo_types_1 = require("./silo.types");
const silo_1 = require("services/configuration/silo");
const color_led_generator_1 = __importDefault(require("utils/color-led-generator"));
const hauler_1 = require("services/master-data/hauler");
const silo_2 = require("services/silo");
const moment_1 = __importDefault(require("moment"));
const driver_1 = require("services/master-data/driver");
const led_text_shorten_1 = require("utils/led-text-shorten");
const defaultDataStates = {
    skip: 0,
    total: 0,
    take: 1000,
    sortable: false,
    filterable: false,
    reorderable: false,
    scrollable: 'none',
};
const getSiloConfig = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_1._getSiloConfigData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: silo_types_1.siloTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataConfigSilo: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { inEdit: false, modified_date: new Date(item.modified_date), brand2_disabled: item.brand1_name ? false : true, brand3_disabled: item.brand2_name ? false : true });
            })
        };
        dispatch({ type: silo_types_1.siloTypes.SET_DATA_SILO_CONFIG, payload: payload });
    }
});
const onDataStateChange = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        dataGrid: [],
        dataStatesHistory,
    };
    dispatch({ type: silo_types_1.siloTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: silo_types_1.siloTypes.SET_ERROR, payload });
};
const setStatus = (payload) => (dispatch) => {
    dispatch({ type: silo_types_1.siloTypes.SET_STATUS, payload });
};
const setLoadingSubmit = (payload) => (dispatch) => {
    dispatch({ type: silo_types_1.siloTypes.SET_SUBMIT_LOADING, payload });
};
const setHex = (payload) => (dispatch) => {
    dispatch({ type: silo_types_1.siloTypes.SET_HEX, payload });
};
const onReset = (payload) => (dispatch) => {
    dispatch({ type: silo_types_1.siloTypes.RESET, payload });
};
const getDataHauler = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const response = yield (0, silo_2._getHauler)(payload);
    if (response.isError) {
        dispatch({
            type: silo_types_1.siloTypes.HAULER_NOT_FOUND,
            payload: {
                onCallWebSocket: true,
                isToast: true,
                messageToast: 'Hauler with tag ' + payload + ' not configure'
            },
        });
    }
    else {
        const payload = {
            dataHauler: Object.assign(Object.assign({}, response.data), { gate_in: new Date(), main_entrance_in: new Date(), driver: {
                    id: response.data.driver_id,
                    driver: response.data.driver_name,
                }, ticket_no: response.data.ticket_no.substring(0, response.data.ticket_no.length - 5) + 'XXXXX' }),
        };
        // const name = response?.data?.driver_name.toUpperCase() || '~~~~'
        // const nameSplit = name.split(' ')
        // const nameShort = nameSplit.length > 1 ? nameSplit[0] + ' ' + nameSplit[1]?.substring(0, 1) + '.' : nameSplit[0]
        const driverShorten = (0, led_text_shorten_1.shortenText)(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.driver_name.toUpperCase()) || '~~~~');
        const dataLED = {
            data: [
                {
                    text: [(_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.hauler_no.toString()],
                    color: [6],
                },
                {
                    text: [driverShorten.length < 12 ? driverShorten : driverShorten.substring(0, 11)],
                    color: [((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.brand_id) == '' ? 0 : colorValue((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.brand_color)],
                },
            ],
        };
        (0, silo_2._postLEDSiloConfig)(dataLED);
        dispatch({ type: silo_types_1.siloTypes.SET_DATA_HAULER, payload });
    }
});
const pushLED = (data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    if (data != undefined) {
        const dataColor = [
            data.brand1_color ? data.brand1_color : '',
            data.brand2_color ? data.brand2_color : '',
            data.brand3_color ? data.brand3_color : '',
        ];
        const dataBrand = [data.brand1_name, data.brand2_name, data.brand3_name];
        const color = [];
        const brand = [];
        for (let index = 0; index < dataBrand.length; index++) {
            if (dataBrand[index] != '') {
                brand.push(dataBrand[index]);
                brand.push(' ');
                color.push((0, color_led_generator_1.default)(dataColor[index]));
                color.push(7);
            }
        }
        brand.splice(-1);
        color.splice(-1);
        const dataLED = {
            data: [
                {
                    text: [data.checkpoint_name.toUpperCase().substring(7, data.checkpoint_name.length)],
                    color: [6],
                },
                {
                    text: brand,
                    color: color,
                },
            ],
        };
        const res = yield (0, silo_2._postLEDSiloConfig)(dataLED);
        console.log(res, dataLED, data, brand);
        dispatch({
            type: silo_types_1.siloTypes.ON_PUSH_LED,
            payload: data,
        });
    }
});
const postDataSilo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _e;
    const { dataHauler } = payload;
    const response = yield (0, silo_2._createTransactionSilo)({
        is_active: true,
        image_penalty_evidence: '',
        gate_out: (0, moment_1.default)().format(),
        brand_id: dataHauler.brand_id,
        ticket_no: dataHauler.ticket_no,
        hauler_id: dataHauler.hauler_id,
        vessel_1_id: dataHauler.vessel1_id,
        vessel_2_id: dataHauler.vessel2_id,
        main_entrance_in: (0, moment_1.default)().format(),
        contractor_id: dataHauler.contractor_id,
        checkpoint_id: dataHauler.checkpoint_id,
        gate_in: (0, moment_1.default)(dataHauler.gate_in).format(),
        capacity_volume_1: dataHauler.capacity_volume1,
        capacity_volume_2: dataHauler.capacity_volume2,
        transaction_type: dataHauler.transaction_type || 'normal',
        driver_id: ((_e = dataHauler === null || dataHauler === void 0 ? void 0 : dataHauler.driver) === null || _e === void 0 ? void 0 : _e.id) ? dataHauler.driver.id : dataHauler.driver_id,
        total_capacity: ((dataHauler === null || dataHauler === void 0 ? void 0 : dataHauler.capacity_volume1) || 0) + ((dataHauler === null || dataHauler === void 0 ? void 0 : dataHauler.capacity_volume2) || 0),
    });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: silo_types_1.siloTypes.ON_SAVE_DATAITEM,
            payload: { dataHauler, errorCode: 0, errorMessage: '', isError: false },
        });
    }
    else {
        dispatch({
            type: silo_types_1.siloTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
    }
});
const setDataSiloTabs = (payload) => (dispatch) => {
    dispatch({ type: silo_types_1.siloTypes.SET_DATA_HOPPER, payload });
};
const getDataHaulerList = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, hauler_1._getMasterHauler)(defaultDataStates);
    const hauler = [];
    response.data.map(i => {
        hauler.push(i.hauler_no);
    });
    dispatch({ type: silo_types_1.siloTypes.GET_HAULER_LIST, payload: { listHauler: hauler } });
});
const getDataHaulerByNo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_2._getHaulerByNo)(payload);
    if (response.isError) {
        dispatch({
            type: silo_types_1.siloTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        dispatch({
            type: silo_types_1.siloTypes.GET_HAULER_BY_NO,
            payload: {
                dataItem: Object.assign(Object.assign({}, response.data), { gate_in: new Date(), ticket_no: response.data.ticket_no.substring(0, response.data.ticket_no.length - 5) + 'XXXXX', driver: {
                        id: response.data.driver_id,
                        driver: response.data.driver_name,
                    } })
            }
        });
    }
});
const getDataHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_2._getTransactionSilo)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: response.isError,
        };
        dispatch({ type: silo_types_1.siloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataHistory: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
                }),
        };
        dispatch({ type: silo_types_1.siloTypes.SET_DATA_HISTORY, payload });
    }
});
const getDataDropdown = ({ contractor_id }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseDriver = yield (0, driver_1._getDriverByContractor)({ id: contractor_id });
    dispatch({
        type: silo_types_1.siloTypes.GET_DROPDOWN, payload: {
            dataDriver: responseDriver.data.map(i => {
                return Object.assign(Object.assign({}, i), { driver: i.driver + ' - ' + i.emp_no });
            }),
        }
    });
});
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStatesHistory };
    dispatch({ type: silo_types_1.siloTypes.ON_PAGE_CHANGE_HISTORY, payload });
});
const colorValue = (dP) => {
    switch (dP) {
        case 'P1':
            return 1;
        case 'P2':
            return 2;
        case 'P3':
            return 3;
        case 'P4':
            return 4;
        case 'P5':
            return 5;
        case 'P6':
            return 6;
        default:
            return 0;
    }
};
exports.default = {
    setHex,
    onReset,
    pushLED,
    setStatus,
    toggleError,
    postDataSilo,
    onSortChange,
    getSiloConfig,
    getDataHauler,
    onFilterChange,
    getDataHistory,
    setDataSiloTabs,
    getDataDropdown,
    onClickMutation,
    setLoadingSubmit,
    onDataStateChange,
    getDataHaulerByNo,
    getDataHaulerList,
    onDataStateChangeHistory,
};
